"use client";

import { createFromIconfontCN } from "@ant-design/icons";

const IconFont = createFromIconfontCN({
  scriptUrl: [`https://cdn.viphrm.com/iconfont/official-website/iconfont.js`]
});

export default IconFont;
